export default __webpack_public_path__ + "locales/zh-CN/ChangeUserStatusDialog.json?hash=1f6bdd7c11b1c9b390db942ba52080ae";